import {
  Component,
  OnInit,
  PLATFORM_ID,
  Inject,
  Renderer2
} from '@angular/core'
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common'
import { Title, Meta } from '@angular/platform-browser'
import { LinkService } from '../../_services/langhfre.service'
import { MatDialog } from '@angular/material/dialog'
import { AiContentFeedbackModalComponent } from 'src/app/Components/ai-content-feedback-modal/ai-content-feedback-modal.component'
import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component'
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NoopScrollStrategy } from '@angular/cdk/overlay'
import { Router } from '@angular/router'
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { NavigationService } from 'src/app/_services/navigation.service'

declare const fpPromise: any;
//declare function ire(string,{}): any;

@Component({
  selector: 'app-ai-detector-tool',
  templateUrl: './ai-detector-tool.component.html',
  styleUrls: ['./ai-detector-tool.component.scss']
})
export class AiDetectorToolComponent implements OnInit {
  inputWordCount: number = 0
  inputText: string = ''
  showWordLimitErr: boolean = false
  wordLimitErrHeading: string = ''
  wordLimitErrMsg: string = ''
  usersCurrentAvailableSessionCount: number = -1
  isSubmitBtnDisabled: boolean = false
  isAIContent: boolean = false
  aiContentScore: number = 0
  humanContentScore: number = 0
  showLoadingState: boolean = false
  showErrorModal: boolean = false
  setUserId: string = null
  contentDetectorLimit: number = 500
  aboveLimitText: string = ''
  isLimitExhausted: boolean = false;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  apiResponse: any = undefined;
  aiContentId: string = "";
  isSubmitting: boolean = false;
  private typingTimer: any;
  constructor (
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private _dialog: MatDialog,
    private _appService: WebsiteService,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle("AI Detector | Free AI Detector for ChatGPT, Gemini & Claude");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka's AI detector is ranked #1 in the RAID benchmark for AI detection & accuracy. Check AI-generated content now with our free AI detector." });
    this.metaTagService.updateTag({ property: 'og:title', content: "AI Detector | Free AI Detector for ChatGPT, Gemini & Claude" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka's AI detector is ranked #1 in the RAID benchmark for AI detection & accuracy. Check AI-generated content now with our free AI detector." });
    this.metaTagService.updateTag({ name: 'keywords', content: 'ai detector,ai checker ,ai content detector, ai content detection, ai content detectors, ai contect detector, chatgpt detector, ai text detector, free ai detector, ai content detector free, ai detector for essays, ai content detection tool, best ai content detector, ai written text detector, ai generated text detector, ai content detector tools' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/ai-content-detector' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/why-choose-Trinka%20-AI-Content-Detector.svg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/ai-content-detector' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "AI Detector | Free AI Detector for ChatGPT, Gemini & Claude" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka's AI detector is ranked #1 in the RAID benchmark for AI detection & accuracy. Check AI-generated content now with our free AI detector." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/why-choose-Trinka%20-AI-Content-Detector.svg' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/ai-content-detector' });
    if (isPlatformServer(this.platformId)) {
      let script = this._renderer2.createElement('script');
      script.type = `application/ld+json`;
      script.text = `
      {"@context":"https://schema.org","@graph":[{"@type":"BreadcrumbList","@id":"https://www.trinka.ai/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"AI Detector","item":"https://www.trinka.ai/ai-content-detector"}]},{"@type":"ProfessionalService","@id":"https://www.trinka.ai/#service","name":"Trinka AI Content Detection Service","image":"https://www.trinka.ai/assets/images/trinka_logo.svg","url":"https://www.trinka.ai/ai-content-detector","logo":"https://www.trinka.ai/assets/images/trinka_logo.svg","description":"Trinka offers a professional AI content detection service that helps users detect and verify AI-generated text with high accuracy, designed for academic, publishing, and enterprise users.","areaServed":{"@type":"Country","name":"Global"},"priceRange":"$0 - $20/month","contactPoint":{"@type":"ContactPoint","telephone":"+91-22-6193-8200","contactType":"Customer Support","email":"support@trinka.ai","availableLanguage":["English"]},"sameAs":["https://www.facebook.com/thetrinkaai/","https://www.instagram.com/thetrinkaai/","https://x.com/thetrinkaai","https://www.linkedin.com/company/thetrinkaai/","https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA"]},{"@type":"WebPage","@id":"https://www.trinka.ai/ai-content-detector#webpage","url":"https://www.trinka.ai/ai-content-detector","name":"AI Detector – Trinka AI","description":"Detect AI-generated content with Trinka’s AI Detector. Identify text written by ChatGPT, Bard, GPT-4, and more with high accuracy.","inLanguage":"en","isPartOf":{"@type":"WebSite","@id":"https://www.trinka.ai/#website"}},{"@type":"FAQPage","@id":"https://www.trinka.ai/ai-content-detector#faq","mainEntity":[{"@type":"Question","name":"What is an AI detector?","acceptedAnswer":{"@type":"Answer","text":"An AI detector or AI detector is specialized software designed to identify whether a piece of text was written by a human or generated by AI tools like ChatGPT."}},{"@type":"Question","name":"How do AI detectors work?","acceptedAnswer":{"@type":"Answer","text":"AI detectors use natural language processing, machine learning, and deep learning techniques to analyze writing patterns and determine whether content is human-written or AI-generated."}},{"@type":"Question","name":"What's the difference between Plagiarism Detection and AI detection?","acceptedAnswer":{"@type":"Answer","text":"Plagiarism detection identifies copied or unoriginal content, while AI detection determines whether content was created by a human or generated by artificial intelligence."}},{"@type":"Question","name":"Can Educators detect if you used an AI assistant like ChatGPT for submissions?","acceptedAnswer":{"@type":"Answer","text":"Yes. Educators can identify AI-generated assignments using AI detection tools, language analysis, and inconsistencies in writing style or content depth."}},{"@type":"Question","name":"Are AI detection tools accurate?","acceptedAnswer":{"@type":"Answer","text":"Accuracy varies by tool, but Trinka AI Detector provides highly reliable detection for content generated by ChatGPT, GPT-4, Bard, and other AI writing tools."}},{"@type":"Question","name":"Can Trinka AI Detector check content quality and grammar related issues beyond AI-generated content?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka offers additional writing tools including Grammar Checker, Punctuation Checker, and Paraphrasing Tool to improve content quality, readability, and structure."}},{"@type":"Question","name":"Does Google detect AI content?","acceptedAnswer":{"@type":"Answer","text":"Yes. Search engines like Google continuously improve their algorithms to identify AI-generated content and maintain search quality standards."}},{"@type":"Question","name":"Can Trinka detect mixed text where human-created text has been amended with AI-generated text?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka can identify both human-written and AI-generated sections within mixed content and provide confidence scores in the detection report."}},{"@type":"Question","name":"Is Trinka AI Detector Free?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka AI Detector is free with limitations, allowing up to 10 sessions per day and 500 words per session. Premium plans provide expanded access."}},{"@type":"Question","name":"Does the tool work with all AI-generated text?","acceptedAnswer":{"@type":"Answer","text":"Yes. The tool is optimized to detect content generated by popular AI models including ChatGPT and other AI text-generation tools."}},{"@type":"Question","name":"Is my content safe when using the tool?","acceptedAnswer":{"@type":"Answer","text":"Yes. Uploaded content is not stored or shared, ensuring user privacy and data security."}},{"@type":"Question","name":"Should I check grammar after using an AI detector?","acceptedAnswer":{"@type":"Answer","text":"Yes. After detecting AI-generated text, it is recommended to use a grammar checker to improve readability, fix language issues, and enhance content quality."}}]}]}
      `;
      this._renderer2.appendChild(this._document.head, script);
  
      let script2 = this._renderer2.createElement('script');
      script2.type = `application/ld+json`;
      script2.text = `
      {"@context":"https://schema.org","@type":"SoftwareApplication","name":"Free AI Detector","operatingSystem":"All","applicationCategory":"AI Content Detection Tool","applicationSubCategory":"Text Analysis","description":"Trinka AI Detector is a web-based tool that detects AI-generated content written by models like ChatGPT, GPT-4, and Bard. Ideal for academic, publishing, and enterprise users.","url":"https://www.trinka.ai/ai-content-detector","image":"https://www.trinka.ai/assets/images/tools/ai-content-detector/ai-content-detector-tool.svg","softwareVersion":"1.0","creator":{"@type":"Organization","name":"Trinka AI","url":"https://www.trinka.ai"},"publisher":{"@type":"Organization","name":"Trinka AI","url":"https://www.trinka.ai"},"offers":{"@type":"Offer","price":"0.00","priceCurrency":"USD","availability":"https://schema.org/InStock","url":"https://www.trinka.ai/ai-content-detector"},"aggregateRating":{"@type":"AggregateRating","ratingValue":"4.7","reviewCount":"275"},"featureList":["Detect AI-generated content from GPT-4, ChatGPT, Bard, and more","Granular detection with section-level confidence scores","Privacy-first – no data stored or shared","10 free sessions per day","Enterprise access with advanced reports"]}
      `;
      this._renderer2.appendChild(this._document.head, script2);
    }
    this.generateAndSetUserId();
    if (isPlatformBrowser(this.platformId)) {
      this.typeText();
    }
    if(this.setUserId) this.getUserSessionCount();
    this._attachKeydownEventListener(document.getElementById('inputEditor'))
    this.attachPasteEventListener(document.getElementById('inputEditor'))
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  onInputEditorChange (txt: string) {
    this._updateCounts(txt)
    this.resetScoreAndInputText()
    if (this.inputWordCount <= 500 && this.isSubmitBtnDisabled) {
      this.isSubmitBtnDisabled = false
    }
  }

  private _wordCount (text) {
    return text.split(/(\s+)/).filter(x => x.trim().length > 0).length
  }

  _updateCounts (txt: string) {
    this.inputText = txt
    this.inputWordCount = this._wordCount(txt.trim())
  }

  openFeedbackModal (likeFlag: boolean): void {
    try {
      const dialogRef = this._dialog.open(AiContentFeedbackModalComponent, {
        width: '500px',
        height: 'auto',
        disableClose: true,
        backdropClass: 'custom-dialog-background',
        panelClass: "border-radius16",
        data: {
          isLiked: likeFlag,
          inputText: this.inputText,
          userID: this.setUserId,
          apiResponse: this.apiResponse,
          aiContentId: this.aiContentId
        },
        scrollStrategy: new NoopScrollStrategy()
      })

      dialogRef.afterClosed().subscribe(result => {
      })
    } catch (e) {
      console.log('Err is: ', e)
    }
  }

  clearEditors (): void {
    this.inputWordCount = 0
    document.getElementById('inputEditor').innerHTML = ''
    this.resetScoreAndInputText()
  }

  sendTextForAIDetection() {
    this.generateAndSetUserId();
    if (this.inputWordCount < 100) {
      this.showWordLimitErr = true
      this.wordLimitErrMsg = ''
      this.wordLimitErrHeading = 'Please write minimum 100 words'
    } else if (this.inputWordCount > 500) {
      //for 500 words limit count
      this.isSubmitBtnDisabled = true
      this.showWordLimitErr = true
      this.wordLimitErrHeading = 'Word limit reached'
      this.wordLimitErrMsg =
        'You can enter <b>500 words</b> at a time. Please shorten the paragraph and retry.'
      // setTimeout(() => {
      //   this.showWordLimitErr = false
      // }, 3000)
    } else if (this.usersCurrentAvailableSessionCount === 0) {
      this.showWordLimitErr = false
      this._dialog.open(DetectionLimitExhaustModalComponent, {
        backdropClass: 'custom-dialog-background',
        width: '490px',
        height: 'auto',
        scrollStrategy: new NoopScrollStrategy(),
        panelClass: "border-radius16",
      })
    } else if (this.showErrorModal) {
      this.clearEditors()
    } else {
      this.showWordLimitErr = false
      this.showLoadingState = true
      //API logic and session count will be deducted here
      let requestBody = {
        text: this.inputText
      }
      this._appService
        .aiDetectionRequest(requestBody, this.setUserId)
        .subscribe({
          complete: () => {},
          next: (response: any) => {
            this.apiResponse = response?.body?.result[0];
            this.showLoadingState = false;
            this.isAIContent = response?.body?.result[0]?.fake
            this.humanContentScore = this.isAIContent
              ? 0
              : response?.body?.result[0].human_score
            this.aiContentScore = this.isAIContent
              ? response?.body?.result[0].ai_score
              : 0
            this.aiContentId = response?.body?.aiContentId;
            this.getUserSessionCount()
            document
              .querySelector('#inputEditor')
              .childNodes.forEach((ele: HTMLElement) => {
                setTimeout(() => {
                  if (this.isAIContent) {
                    ele.style.backgroundColor = '#DC262626'
                    ele.style.color = '#DC2626'
                    ele.style.display = 'inline'
                    ele.style.fontWeight = '600'
                    ele.style.lineHeight = '26px'
                  }
                }, 500)
              })
          },
          error: error => {
            console.log('Error is: ', error);
            this.showLoadingState = false
            if (error?.status === 400 || error?.error?.error === 'Rate limit exceeded for today. Try again tomorrow.') {
              this.showWordLimitErr = false;
              this._dialog.open(DetectionLimitExhaustModalComponent, {
                backdropClass: 'custom-dialog-background',
                width: '490px',
                height: 'auto',
                scrollStrategy: new NoopScrollStrategy(),
                panelClass: "border-radius16",
              });
              this.usersCurrentAvailableSessionCount = 0;
            }
            else {
              this.showErrorModal = true;
              this.wordLimitErrMsg = '';
            }
          }
        })
    }
  }

  hideLimitError () {
    this.showWordLimitErr = false
  }

  resetScoreAndInputText () {
    this.isAIContent = false
    this.showErrorModal = false
    this.showLoadingState = false
    this.showWordLimitErr = false
    this.aiContentScore = 0
    this.humanContentScore = 0
  }

  private _attachKeydownEventListener (element: HTMLElement) {
    element.onfocus = (e: any) => {
      if (!element.children.length) {
        let newParagraph = document.createElement('p')
        newParagraph.innerHTML = '<br />'
        element.appendChild(newParagraph)
        window.getSelection().collapse(newParagraph, 0)
        e.preventDefault()
      }

      //TODO: To be added only if we want to disable Trinka's extension on the AI Detector's text-editor
      // if(document.querySelector('trinka-extension') && (document.querySelector('trinka-extension') as HTMLElement).style.display !== 'none') (document.querySelector('trinka-extension') as HTMLElement).style.display = 'none';
    }
    element.onblur = (e: any) => {
      if (!element.textContent) {
        element.innerHTML = ''
      }
      e.preventDefault()
    }
  }

  async generateAndSetUserId() {
    const today = new Date();
    const dateKey = `${today.getDate()}${today.getMonth() + 1}${today.getFullYear()}`
    this.setUserId = localStorage.getItem(dateKey)
    if (!this.setUserId) {
      const fingerprintJSResponse = (await (await fpPromise).get());
      this.setUserId = fingerprintJSResponse.visitorId;
      localStorage.setItem(dateKey, this.setUserId);
      this.getUserSessionCount();
    }
  }


  attachPasteEventListener(element: HTMLElement) {
    element.addEventListener('paste', ($event: any) => {
      $event.preventDefault()
      let text = $event.clipboardData.getData('text/plain');
      text = text.replace(/\n{2,}/g, '\n');
      document.execCommand('insertText', false, text);
    });
  }
  getUserSessionCount() {
    if (this.setUserId) {
      this._appService.getAIDetectionSessionCount(this.setUserId).subscribe({
        next: (response: any) => {
          this.usersCurrentAvailableSessionCount = response?.count;
        },
        complete: () => { },
        error: (err: any) => {
          this.usersCurrentAvailableSessionCount = 0;
        }
      })
    } 
    else this.usersCurrentAvailableSessionCount = 10;
  }

  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/client_logos/HarvardMedicalSchool.png", "altText": "harvard medical school" },
    { "imgSrc": "/assets/images/client_logos/StanfordUniversity.png", "altText": "stanford university" },
    { "imgSrc": "/assets/images/client_logos/PrincetonUniversity.png", "altText": "princeton universities" },
    { "imgSrc": "/assets/images/client_logos/MIT.png", "altText": "mit" },
    { "imgSrc": "/assets/images/client_logos/Yale.png", "altText": "yale universities" },
    { "imgSrc": "/assets/images/client_logos/Yonsei_University.png", "altText": "yonsei university" },
    { "imgSrc": "/assets/images/client_logos/nippon-institute.png", "altText": "university of tokyo" },
    { "imgSrc": "/assets/images/client_logos/oxford.png", "altText": "oxford universities" },
    { "imgSrc": "/assets/images/client_logos/cambridge.png", "altText": "cambridge universities" }
  ];

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  displayText = '';
  showUnderline = false;

  texts = [
    'ChatGPT, Claude & more',
    'paraphrased AI text',
    'AI-edited writing',
    'humanized text'
  ];

  currentIndex = 0;
  charIndex = 0;

  typingSpeed = 80;
  backspaceSpeed = 50;

  typeText() {
    const text = this.texts[this.currentIndex];

    if (this.charIndex < text.length) {

      this.displayText += text.charAt(this.charIndex);
      this.charIndex++;

      this.typingTimer = setTimeout(() => {
        this.typeText();
      }, this.typingSpeed);

    } else {

      // finished typing - show underline
      this.showUnderline = true;

      // hold for 2 seconds
      setTimeout(() => {
        this.showUnderline = false;
        this.backspaceText();
      }, 2000);
    }
  }


  backspaceText() {

    if (this.charIndex > 0) {

      this.displayText = this.displayText.substring(
        0,
        this.charIndex - 1
      );

      this.charIndex--;

      setTimeout(() => {
        this.backspaceText();
      }, this.backspaceSpeed);

    } else {

      // move to next text
      this.currentIndex++;

      if (this.currentIndex >= this.texts.length) {
        this.currentIndex = 0;
      }

      setTimeout(() => {
        this.typeText();
      }, 300);
    }
  }
  ngOnDestroy() {
    if (this.typingTimer) {
      clearTimeout(this.typingTimer);
    }
  }
  
}
